import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Avatar, Badge } from "antd";
import StandardTableLayout from "../../layouts/StandardTableLayout/StandardTableLayout";
import StandardListLayout from "../../layouts/StandardTableLayout/StandardListLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_ITEM_CATEGORY,
  setItemCategory,
  DELETING_ITEM_CATEGORY,
} from "../../store/items-store/reducer";

const ItemCategory = () => {
  const dispatch = useDispatch();
  const { organisationId } = useSelector(({ auth }) => auth.user);
  const { itemCategory } = useSelector(({ items }) => items.itemReducer);
  const [isLoading, setIsLoading] = useState(true);
  const { csvExportData } = useSelector(({ user }) => user.userReducer);
  const [dataList, setDataList] = useState([]);
  const [csv, setCsv] = useState({
    headers: [
      {
        label: "Code",
        key: "code",
      },
      {
        label: "Name",
        key: "name",
      },
      {
        label: "Status",
        key: "status",
      },
    ],
    data: [],
    fileName: "allItemCategory.csv",
  });

  const handleColumnCsv = (array) => {
    let csvData = [];
    array?.forEach((e) => {
      csvData.push({
        code: e.code,
        name: e.name,
        status: e.status,
      });
    });
    return csvData;
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => a.code.localeCompare(b.code),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let type = status === true ? "success" : "error";
        return <Badge status={type} text={status ? "Active" : "InActive"} />;
      },
      sorter: (a, b) => b.status - a.status,
    },
  ];

  const FETCH_DATA = () => {
    FETCH_ITEM_CATEGORY(organisationId)
      .then((data) => dispatch(setItemCategory(data)))
      .finally(() => setIsLoading(false));
    setIsLoading(false);
  };

  useEffect(() => {
    FETCH_DATA();
  }, [organisationId]);

  useEffect(() => {
    if (itemCategory) {
      const columns = handleColumnCsv(itemCategory);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [itemCategory]);

  useEffect(() => {
    if (csvExportData.length > 0) {
      const columns = handleColumnCsv(csvExportData);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [csvExportData]);

  useEffect(() => {
    const newDoc = [];
    itemCategory?.forEach((ele, index) => {
      let data = {
        _id: ele?._id,
        title: `${ele?.name}`,
        description: `${ele?.code}`,
      };
      newDoc.push(data);
    });
    setDataList(newDoc);
  }, [itemCategory]);

  return (
    <div className="team_member">
      <div className="table-layouts">
        <div className="tables">
          <StandardTableLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Item Categories" }]}
            dataSource={itemCategory && itemCategory}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_ITEM_CATEGORY}
            table="items/category"
          />
        </div>
        <div className="table-lists">
          <StandardListLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Item Categories" }]}
            dataList={dataList}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_ITEM_CATEGORY}
            table="items/category"
          />
        </div>
      </div>
    </div>
  );
};

export default ItemCategory;
